import AccountContent from '~/components/Account/Logged'
import { PageViewAnalytics } from '~/components/PageViewAnalytics'

import withAuthentication from '~/hocs/withAuthentication'

import getAccountPageServerSideProps from '~/data/account-page-data'
import { AccountPageData } from '~/data/account-page-data/serializer'

function AccountPage({ accountPage }: AccountPageData) {
  return (
    <>
      <AccountContent {...accountPage} />
      <PageViewAnalytics template="customers/account" />
    </>
  )
}

export default withAuthentication(AccountPage)

export const getServerSideProps = getAccountPageServerSideProps()
